// extracted by mini-css-extract-plugin
export var completionBody = "_cd-2";
export var completionCard = "_cd-0";
export var completionFooter = "_cd-3";
export var completionTitle = "_cd-1";